import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FarmerCreateOptionsType, FarmersService } from '~/api/services/farmers';
import Drawer from '~/components/Drawer';
import { LocationEl } from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Locations/style';
import { GlobalEl } from '~/styles/app';
import AmountFarmerGroup from '../../../CreateEditFarmers/Forms/AmountFarmerGroup';
import { useParams } from 'react-router-dom';
import { handleErrors } from '~/utils/helpers';
import notify from '~/components/Notify';

interface Props {
  editAmountData: any
  handleHiddenDrawer: (submited?: boolean) => void
  farmerOptions: FarmerCreateOptionsType
}

const EditAmountDrawer:React.FC<Props> = (props) => {
  const { editAmountData, handleHiddenDrawer } = props
  const { t } = useTranslation()
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  const methods = useForm({
    mode: 'onChange'
  })

  useEffect(() => {
    if(editAmountData) {
      methods.reset(editAmountData)
    }
  }, [editAmountData])

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if (data.amountType === 'year') {
        delete data.amounts
      } else {
        delete data.amount
      }
      await FarmersService.updateHedginInfo(id, data)
      notify(t('Successfully updated hedging info'), 'success')
      handleHiddenDrawer(true)
    }catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderContent() {
    return <>
      <FormProvider {...methods}>
        <AmountFarmerGroup farmersOptions={props.farmerOptions}/>
      </FormProvider>
      <LocationEl.DrawerFooter>
        <GlobalEl.PrimaryButton
        >
          {t('Save')}
        </GlobalEl.PrimaryButton>
      </LocationEl.DrawerFooter>
    </>
  }

  return <Drawer
    onHide={() => {
      methods.reset();
      handleHiddenDrawer();
    }}
    handleSubmit={methods.handleSubmit(onSubmit)}
    isBusy={isBusy}
    header={t('Edit amount')}
    content={Boolean(editAmountData) && renderContent()}
    isVisible={Boolean(editAmountData)}
    closeOnEscape
  />
}
export default EditAmountDrawer